import { Breadcrumb } from "@components/anti/Breadcrumb"
import Link from "@components/anti/Link"
import { linkProductsServices } from "src/helper/page-url"
import { translations } from "src/helper/translations"

export function ServicesTab({ tab, locale }) {
  const listTab = [
    { title: translations[`studio_booking_${locale}`], slug: "studio-booking" },
    { title: translations[`advertising_${locale}`], slug: "advertising" },
    { title: translations[`promotion_${locale}`], slug: "promotion" },
  ]

  return (
    <section className="pb-3 sc-services-tab">
      <div className="container">
        <div className="pb-4">
          <Breadcrumb
            path={[
              {
                title: translations[`product_services_${locale}`],
                url: linkProductsServices,
              },
              { title: translations[`services_${locale}`] },
            ]}
            // path="/products-&-services/services"
            theme="light"
          />
        </div>

        <div className="services-list-wrapper">
          <ul className="services-list">
            {listTab.map((item, i) => (
              <li
                className={`services-item ${tab === item.slug ? "active" : ""}`}
                key={`${i}-${item.slug}`}
              >
                <Link
                  className="services-link"
                  href={`${linkProductsServices}/services/${item.slug}`}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
